import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface VideoProgressState {
  progressByParentId: Record<string, number>;
}

interface SetVideoProgressPayload {
  parentId: string;
  time: number;
}

const initialState: VideoProgressState = {
  progressByParentId: {},
};

const videoProgressSlice = createSlice({
  name: "videoProgress",
  initialState,
  reducers: {
    setVideoProgress: (
      state,
      action: PayloadAction<SetVideoProgressPayload>,
    ) => {
      const { parentId, time } = action.payload;

      if (!parentId) {
        return;
      }

      state.progressByParentId[parentId] = Math.max(0, time);
    },
    clearVideoProgress: (state, action: PayloadAction<string>) => {
      delete state.progressByParentId[action.payload];
    },
  },
});

export const { setVideoProgress, clearVideoProgress } =
  videoProgressSlice.actions;
export default videoProgressSlice.reducer;
